  <!-- 油卡流水账 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
      </template>
    </input-plug>

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
      </template>
    </input-plug>
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "油卡流水账", //导出时默认文件名
        apiName: "/admin/v3/tms/car/oil/fundflow/getOilCardFundflowList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "油卡号",
          field: "oilCardNumber",
          placeholder: "请输入",
        },
      ],

      queryData: {
        oilCardNumber: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "发生时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "GascardDaybook", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "流水号",
          field: "number",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发生时间",
          field: "handleTime",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "油卡号码",
          field: "oilCardNumber",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "车牌号码",
          field: "carNumber",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "交易金额",
          field: "amount",
          sort: 6,
          isShow: true,
          isSort: true,
        },
        {
          name: "油卡余额",
          field: "balance",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "类型",
          field: "operationTypeShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "经办人",
          field: "handleUserName",
          sort: 1,
          isShow: true,
        },

        {
          name: "备注",
          field: "remarks",
          sort: 19,
          isShow: true,
        },
      ],
      sortName: "油卡流水账列表", //  排序名
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取油卡流水账列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.OilCardFundflowList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---油卡流水账列表`);
        }
      });
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      console.log("表格选择事件");
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
  },
};
</script>
            <style scoped lang="less">
</style>
            